/**
 * CameraPanel Component
 * EXACT PORT dari ModelViewerBACKUP.jsx line 11652-11712
 * 
 * Camera selector dropdown untuk switch antara:
 * - Default Orbit Camera
 * - Imported GLB Cameras
 */

import React from 'react'

export default function CameraPanel({
  isOpen,
  onClose,
  isMobile,
  viewportReady,
  cameras = [],
  selectedCamera,
  setSelectedCamera,
  selectedCameraRef,
}) {
  if (!isOpen || !viewportReady || cameras.length === 0) return null

  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        left: '88px',
        zIndex: 17,
        width: isMobile ? 'calc(100% - 120px)' : '340px',
        background:
          'linear-gradient(135deg, rgba(20, 20, 30, 0.72) 0%, rgba(10, 10, 15, 0.78) 100%)',
        backdropFilter: 'blur(24px) saturate(190%)',
        WebkitBackdropFilter: 'blur(24px) saturate(190%)',
        borderRadius: '16px',
        padding: '20px',
        boxShadow:
          '0 8px 24px rgba(0, 0, 0, 0.15), 0 16px 48px rgba(0, 0, 0, 0.12)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        border: '0.5px solid rgba(255, 255, 255, 0.18)',
        borderTop: '0.5px solid rgba(255, 255, 255, 0.25)',
        color: '#fff',
        animation:
          'slideInFromLeft 0.5s cubic-bezier(0.32, 0.72, 0, 1) 0.1s forwards',
        opacity: 0,
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
    >
      {/* Header */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          🎥 Camera View
        </h3>
        <button
          onClick={onClose}
          style={{
            padding: '6px 10px',
            backgroundColor: 'rgba(239, 68, 68, 0.2)',
            color: '#ef4444',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '12px',
          }}
        >
          ✕
        </button>
      </div>

      {/* Camera Selector Dropdown */}
      <div style={{ marginBottom: '16px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '13px',
            opacity: 0.7,
          }}
        >
          🎥 Camera View
        </label>
        <select
          value={selectedCamera}
          onChange={(e) => {
            const newCamera = e.target.value
            console.log('🎥 Switching camera to:', newCamera)
            setSelectedCamera(newCamera)
            if (selectedCameraRef) {
              selectedCameraRef.current = newCamera
            }
          }}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#1e1e23',
            color: '#fff',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            fontSize: '14px',
            cursor: 'pointer',
            fontFamily: 'system-ui, -apple-system, sans-serif',
          }}
        >
          <option value="default">🎮 Default (Orbit Control)</option>
          {cameras.map((cam) => (
            <option key={cam.name} value={cam.name}>
              🎥 {cam.name}
            </option>
          ))}
        </select>
        <p
          style={{
            fontSize: '11px',
            opacity: 0.5,
            margin: '8px 0 0 0',
          }}
        >
          {selectedCamera === 'default'
            ? 'Use mouse to control camera'
            : 'Using camera position, rotation & animation from GLB'}
        </p>
      </div>
    </div>
  )
}

